const NotFound404 = () => {
  return <div>Not Found 404</div>;
};

export default NotFound404;
